import { Backdrop, CircularProgress } from "@mui/material";

const Loading = ({ isLoading }) => {
  return (
    <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.modal + 2,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          cursor: "wait",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loading;